import React, { useEffect } from 'react';

function isInstagram(url) {
  return /instagram\.com/i.test(url);
}
function isFacebook(url) {
  return /facebook\.com|fb\.watch/i.test(url);
}
function getYouTubeId(url) {
  const match = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
  return match ? match[1] : null;
}

// Renders an existing Facebook/Instagram post or a YouTube video as an
// embed, platform detected from the URL — used anywhere a video is added
// by pasting a link rather than uploading a file, so it costs zero server
// storage (the video stays hosted on YouTube/Facebook/Instagram's own
// servers; this site only ever stores the URL).
export default function SocialVideoEmbed({ url, className = '' }) {
  const instagram = url && isInstagram(url);

  useEffect(() => {
    if (!instagram) return;
    // Instagram's embed.js only hydrates <blockquote> tags present when the
    // script first loads; a re-render (URL change, client-side nav to this
    // page again) needs an explicit reprocess call instead of a fresh script.
    const process = () => window.instgrm?.Embeds?.process();
    if (window.instgrm) { process(); return; }
    const existing = document.querySelector('script[src*="instagram.com/embed.js"]');
    if (existing) {
      existing.addEventListener('load', process);
      return () => existing.removeEventListener('load', process);
    }
    const script = document.createElement('script');
    script.src = 'https://www.instagram.com/embed.js';
    script.async = true;
    script.onload = process;
    document.body.appendChild(script);
  }, [instagram, url]);

  if (!url) return null;

  const youtubeId = getYouTubeId(url);
  if (youtubeId) {
    return (
      <div className={className}>
        <div className="aspect-video">
          <iframe
            src={`https://www.youtube-nocookie.com/embed/${youtubeId}`}
            className="w-full h-full" style={{ border: 'none' }}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen title="Video" />
        </div>
      </div>
    );
  }

  if (instagram) {
    return (
      <div className={className}>
        <blockquote className="instagram-media" data-instgrm-permalink={url} data-instgrm-version="14" style={{ width: '100%', margin: 0 }} />
      </div>
    );
  }

  if (isFacebook(url)) {
    return (
      <div className={className}>
        <iframe
          src={`https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(url)}&show_text=false`}
          width="100%" height="400" style={{ border: 'none', overflow: 'hidden' }}
          scrolling="no" frameBorder="0"
          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
          allowFullScreen title="Careers video" />
      </div>
    );
  }

  return null;
}
